import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import {
  GetEnums,
  GetEnumsSuccess,
  GetEnumsFailed,
} from './enumeration.actions';
import { EnvService } from '../../services/env.service';
import { getCurrentLabelsJson } from '../labels';
import { select, Store } from '@ngrx/store';
import { langSpecificEnums } from '../utils';

@Injectable()
export class EnumsEffects {
  private enumUrl(endpoint: string): string {
    // TODO:TIM Requirements changed, so this can probably be refactored into a single string value, and just interpolate the v2 or v3
    return endpoint === 'v3'
      ? `${this.envService.apiUrl}/v3/reference-data/enumerations?`
      : `${this.envService.apiUrl}/v2/reference-data/enumerations?`;
  }

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private envService: EnvService,
    private store: Store
  ) {}

  public getEnumerations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetEnums),
      switchMap((action) =>
        combineLatest([
          of(action.getEnumRequest),
          of(action.endpoint),
          this.store.pipe(select(getCurrentLabelsJson)),
        ])
      ),
      mergeMap(([getEnumRequest, endpoint, currentLabels]) => {
        return this.http
          .get(
            `${this.enumUrl(endpoint)}userLanguage=${getEnumRequest.userLanguage}&targetAudience=CUSTOMER_FACING&transactingCountryCode=${getEnumRequest.countryCode}`
          )
          .pipe(
            map((data: any) => {
              const labels: any = currentLabels?.labels;
              const enumsObj = labels?.stellar?.enumsObj;
              1;

              if (data && data.length > 0 && enumsObj) {
                data = langSpecificEnums(data, enumsObj);
              }

              return GetEnumsSuccess({ getEnumsResponse: data });
            }),
            catchError((error) => of(GetEnumsFailed({ error })))
          );
      })
    )
  );

  langSpecificEnums(data: any, enumsObj: any) {
    //if langauge other than english, map the description from cms labels enum
    return data.map((d: any) => {
      const enumItem = enumsObj[d.name];
      if (enumItem) {
        d.items = d.items.map((di: any) => {
          const enumvalueItem = enumItem[di.value];
          if (enumvalueItem) {
            di.description = enumvalueItem;
          }
          return di;
        });
      }
      return d;
    });
  }
}
